module.exports = __webpack_public_path__ + "static/media/WEO76APP0001.e0927850.svg";